"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountProfileError = exports.mountReadOnlyMessage = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ReadOnlyMessage = function () { return (react_1.default.createElement(kaleidoscope_1.Card, { className: "readonly-message", elevation: 1 },
    react_1.default.createElement("div", { className: "readonly-message__icon" },
        react_1.default.createElement(icons_1.Contact, { size: icons_1.IconSize.Large })),
    react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true }, "Contact support to edit your email"),
    react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
        "Changing your email now affects both your Qwilr and Springboard profiles. We'll support changing these in one place in the app soon, but for now please",
        " ",
        react_1.default.createElement(kaleidoscope_1.Link, { href: "mailto:help@qwilr.com?subject=Qwilr and Springboard profile change request" }, "contact support"),
        " to make any changes."))); };
var ProfileErrorAlert = function () { return (react_1.default.createElement("div", { className: "user-profile-error" },
    react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, "We're unable to verify your profile information at the moment, please try again later."))); };
var mountReadOnlyMessage = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(ReadOnlyMessage, null));
};
exports.mountReadOnlyMessage = mountReadOnlyMessage;
var mountProfileError = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(ProfileErrorAlert, null));
};
exports.mountProfileError = mountProfileError;
